// Hex values behind the Color and Tint props. Generated from the design team's Figma export by scripts/generate-colors.ts.
// Do not edit by hand: see README_INTERNAL.md.

const COLORS = {
  AQUA: {
    LIGHTEST: '#f0f7ff',
    LIGHT: '#cce4ff',
    NORMAL: '#99c9ff',
    DARK: '#0070f0',
    DARKEST: '#004fa8',
  },
  GOLD: {
    LIGHTEST: '#fff6e5',
    LIGHT: '#ffda8f',
    NORMAL: '#ffcc66',
    DARK: '#eb9c00',
    DARKEST: '#8f3c00',
  },
  NEUTRAL: {
    LIGHTEST: '#ffffff',
    LIGHT: '#f6f6f9',
    NORMAL: '#e4e4e7',
    DARK: '#c0c0c4',
    DARKEST: '#65656e',
  },
  MINT: {
    LIGHTEST: '#f0fafa',
    LIGHT: '#56d2d2',
    NORMAL: '#00b2b2',
    DARK: '#00878a',
    DARKEST: '#004a4d',
  },
  RUBY: {
    LIGHTEST: '#ffefeb',
    LIGHT: '#ffbea8',
    NORMAL: '#ff7142',
    DARK: '#e84b17',
    DARKEST: '#992600',
  },
  TEAL: {
    LIGHTEST: '#f0f5fc',
    LIGHT: '#c0cdde',
    NORMAL: '#647990',
    DARK: '#2a3a4c',
    DARKEST: '#191b1f',
  },
  VIOLET: {
    LIGHTEST: '#e9e8ff',
    LIGHT: '#d4d2fe',
    NORMAL: '#4f1fff',
    DARK: '#2800b8',
    DARKEST: '#1b007a',
  },
};

export default COLORS;
